import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useMall } from "@/context/MallContext";

/** The shop a catalog page is standing in: `?store=` on the link wins, then the shop already entered. */
export function useShop() {
    const { store, shopSlug, ensureStore, enter } = useMall();
    const [sp] = useSearchParams();
    const param = sp.get("store");

    useEffect(() => { ensureStore(); }, [ensureStore]);
    useEffect(() => {
        if (!param || param === store?.slug) return;
        api.get(`/stores/${param}`)
            .then(({ data }) => { if (data.store?.status === "active") enter({ ...data.store, designers: data.store.designers_enabled }, "link"); })
            .catch(() => { });
    }, [param, store?.slug, enter]);

    return { shopSlug: param || shopSlug || null, store };
}
